export const SUPABASE_CONFIG = {
  url: process.env.NEXT_PUBLIC_SUPABASE_URL!,
  // Prefer the modern publishable key (sb_publishable_…); fall back to the
  // legacy anon JWT so deploys stay green until the new Vercel var is set.
  publishableKey:
    process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY ??
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  auth: {
    flowType: "pkce" as const,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    redirectTo: process.env.NEXT_PUBLIC_REDIRECT_TO_LOCAL || "http://localhost:3000/auth/callback",
  },
};

// Validation
if (!SUPABASE_CONFIG.url || !SUPABASE_CONFIG.publishableKey) {
  throw new Error("Missing required Supabase environment variables");
}
